import { render, staticRenderFns } from "./ChallengeRedirect.vue?vue&type=template&id=28822d63&"
import script from "./ChallengeRedirect.vue?vue&type=script&lang=ts&"
export * from "./ChallengeRedirect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports